import { render, staticRenderFns } from "./ViewCustomerRequest.vue?vue&type=template&id=2b373060"
import script from "./ViewCustomerRequest.vue?vue&type=script&lang=js"
export * from "./ViewCustomerRequest.vue?vue&type=script&lang=js"
import style0 from "./ViewCustomerRequest.vue?vue&type=style&index=0&id=2b373060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports